<template>
    <section
        class="hi-table-wrapper"
        :class="[hideHeader ? 'hide-header' : '']"
    >
        <el-table
            :data="cloneData"
            style="width: 100%"
            tooltip-effect="dark"
            @selection-change="selectionChange"
            v-loading="loading"
            @select="selectRow"
            @select-all="selectRow"
            :class="{ 'el-table_radio': select === 'radio' }"
            ref="table"
            :stripe="stripe"
            :row-class-name="rowClassName"
            :border="border"
        >
            <el-table-column
                fixed="left"
                label=" "
                width="15"
                v-if="showNewIcon"
            >
                <template slot-scope="scope">
                    <svg-icon
                        v-if="scope.row.showNew"
                        icon-class="new-icon"
                        class-name="new-icon__name"
                    ></svg-icon>
                </template>
            </el-table-column>
            <el-table-column
                v-if="select && position === 'left'"
                type="selection"
                :selectable="selectable"
                align="center"
                fixed="left"
                label="操作(单选)"
                width="50"
            >
            </el-table-column>
            <!-- v-if="index && position === 'right'" -->
            <el-table-column
                type="index"
                :align="align"
                label="序号"
                width="50"
                v-if="showIndex"
            >
            </el-table-column>

            <template v-for="(item, index) in _tableHeaders">
                <el-table-column
                    v-if="!item.renderHeader"
                    :prop="item.headerKey"
                    :width="item.width || defaultWidth"
                    :align="item.align || align"
                    :label="item.headerName"
                    show-overflow-tooltip
                    :key="item.headerKey"
                >
                    <template slot-scope="scope">
                        <template v-if="item.hasOwnProperty('img')">
                            <img
                                v-if="
                                    item.img.type ||
                                    item.img.value === scope.row[item.img.key]
                                "
                                :src="item.img.url"
                                width="12"
                            />
                        </template>
                        <a
                            v-if="item.click"
                            type="text"
                            class="table-a-wrapper"
                            @click.stop="clickFirst(scope.row, item, index)"
                        >
                            {{ formatRow(scope.row, item) }}
                        </a>
                        <template v-else-if="item.ableInput">
                            <el-input
                                style="width: 70%; margin-right: 10px"
                                :type="item.inputType"
                                @input="changeInput"
                                v-model="scope.row[item.headerKey]"
                            >
                            </el-input>
                            {{ item.tips }}
                        </template>
                        <template v-else-if="item.ableSelect">
                            <div>
                                <el-select
                                    placeholder="请选择"
                                    v-model="scope.row[item.headerKey]"
                                >
                                    <el-option
                                        v-for="itm in item.rowOptions"
                                        :key="itm[item.defaultKey.value]"
                                        :label="itm[item.defaultKey.label]"
                                        :value="itm[item.defaultKey.value]"
                                    >
                                    </el-option>
                                </el-select>
                            </div>
                        </template>
                        <template v-else-if="item.image">
                            <img
                                class="nb-image"
                                :src="scope.row[item.headerKey]"
                                alt=""
                            />
                        </template>
                        <template v-else-if="item.render">
                            <node-content
                                :node="scope.row"
                                :h="item.render"
                            ></node-content>
                        </template>
                        <template v-else-if="item.tag">
                            <el-tag
                                effect="dark"
                                size="mini"
                                :type="formatTag(scope.row, item)"
                                >{{ formatRow(scope.row, item) }}</el-tag
                            >
                        </template>
                        <template
                            v-else-if="item.copy && scope.row[item.headerKey]"
                        >
                            <div
                                class="table-copy ellipsis"
                                id="sha"
                                :data-clipboard-text="
                                    formatRow(scope.row, item)
                                "
                                @click="copyTabel(formatRow(scope.row, item))"
                            >
                                {{ formatRow(scope.row, item) }}
                            </div>
                        </template>
                        <template v-else>
                            {{ formatRow(scope.row, item) }}
                        </template>
                    </template>

                    <el-table-column
                        v-for="item0 in item.mergeHeader"
                        :prop="item0.headerKey"
                        :label="item0.headerName"
                        width="120"
                        aligin="center"
                        :key="item0.headerKey"
                    >
                    </el-table-column>
                </el-table-column>

                <el-table-column
                    v-else
                    :prop="item.headerKey"
                    :width="item.width || defaultWidth"
                    :align="align"
                    :label="item.headerName"
                    show-overflow-tooltip
                    :key="item.headerKey + ''"
                >
                    <template slot="header" slot-scope="scope">
                        <node-content
                            :node="scope"
                            :h="item.renderHeader"
                        ></node-content>
                    </template>
                    <template slot-scope="scope">
                        <template v-if="item.hasOwnProperty('img')">
                            <img
                                v-if="
                                    item.img.type ||
                                    item.img.value === scope.row[item.img.key]
                                "
                                :src="item.img.url"
                                width="12"
                            />
                        </template>
                        <a
                            v-if="item.click"
                            type="text"
                            class="table-a-wrapper"
                            @click.stop="clickFirst(scope.row, item, index)"
                        >
                            {{ formatRow(scope.row, item) }}
                        </a>
                        <template v-else-if="item.ableInput">
                            <el-input
                                style="width: 70%; margin-right: 10px"
                                :type="item.inputType"
                                @input="changeInput"
                                v-model="scope.row[item.headerKey]"
                            >
                            </el-input>
                            {{ item.tips }}
                        </template>
                        <template v-else-if="item.ableSelect">
                            <div>
                                <el-select
                                    placeholder="请选择"
                                    v-model="scope.row[item.headerKey]"
                                >
                                    <el-option
                                        v-for="itm in item.rowOptions"
                                        :key="itm[item.defaultKey.value]"
                                        :label="itm[item.defaultKey.label]"
                                        :value="itm[item.defaultKey.value]"
                                    >
                                    </el-option>
                                </el-select>
                            </div>
                        </template>
                        <template v-else-if="item.image">
                            <img
                                class="nb-image"
                                :src="scope.row[item.headerKey]"
                                alt=""
                            />
                        </template>
                        <template v-else-if="item.render">
                            <node-content
                                :node="scope.row"
                                :h="item.render"
                            ></node-content>
                        </template>
                        <template v-else-if="item.tag">
                            <el-tag
                                effect="dark"
                                size="mini"
                                :type="formatTag(scope.row, item)"
                                >{{ formatRow(scope.row, item) }}</el-tag
                            >
                        </template>
                        <template
                            v-else-if="item.copy && scope.row[item.headerKey]"
                        >
                            <div
                                class="table-copy ellipsis"
                                id="sha"
                                :data-clipboard-text="
                                    formatRow(scope.row, item)
                                "
                                @click="copyTabel(formatRow(scope.row, item))"
                            >
                                {{ formatRow(scope.row, item) }}
                            </div>
                        </template>
                        <template v-else>
                            {{ formatRow(scope.row, item) }}
                        </template>
                    </template>

                    <el-table-column
                        v-for="item0 in item.mergeHeader"
                        :prop="item0.headerKey"
                        :label="item0.headerName"
                        width="120"
                        aligin="center"
                        :key="item0.headerKey"
                    >
                    </el-table-column>
                </el-table-column>
            </template>

            <el-table-column
                v-if="select && position === 'right'"
                type="selection"
                :selectable="selectable"
                align="center"
                fixed="right"
                label="操作(单选)"
                width="70"
            >
            </el-table-column>
            <el-table-column
                v-if="filterClickData(clickData).length"
                fixed="right"
                label="操作"
                align="center"
                header-align="center"
                :width="rightWidth || fixedWidth"
            >
                <template
                    slot-scope="scope"
                    v-if="filterClickData(clickData).length"
                >
                    <el-button
                        v-for="item in filterClickData(clickData, scope.row)"
                        @click="
                            handleClick({ row: scope.row, type: item.value })
                        "
                        :type="item.type || 'text'"
                        :key="item.value"
                        :class="item.colorType"
                        :style="{ color: item.color || '' }"
                    >
                        {{ item.label }}
                    </el-button>
                </template>
                <slot></slot>
            </el-table-column>
        </el-table>
        <div class="pagination-wrapper" v-if="pageModel && fetchList">
            <div class="pagination-total">
                共 {{ filterTotal(total) }} 项数据
            </div>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="pageSize"
                :page-size="pageModel.size"
                :current-page="pageModel.page"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                background
            >
            </el-pagination>
        </div>
    </section>
</template>

<script>
import { cloneDeep, isEqual } from 'lodash';
import { formatTable } from '@/utils/validate';
import Sortable from "sortablejs";

export default {
    data() {
        return {
            pageSize: [10, 20, 50, 100],
            widthMap: {
                1: '70',
                2: '120',
                3: '150',
                4: '200',
                5: '300',
                6: '350',
                7: '170',
                8: '190',
                9: '200'
            },
            data: [],
            value1: [],
            cloneField: cloneDeep(this.field),
            sortFlag: true,
            searchList: [],
            headerMaps: this.headerMap,
            tableRadio: '',
            tableHeight: 0,
            cloneHeaders: cloneDeep(this.tableHeaders),
            cloneData: this.tableData,
            cloneRow: null,
            target: null,
            selIds: []
        };
    },
    props: {
        total: Number,
        loading: Boolean,
        sortable: Boolean,
        border: Boolean,
        hideHeader: Boolean,
        stripe: Boolean,
        showNewIcon: Boolean,
        tableHeaders: {
            type: Array,
            default: () => []
        },
        tableData: {
            type: Array,
            default: () => []
        },
        select: String,
        radio: Boolean,
        showIndex: {
            type: Boolean,
            default: true
        },
        index: {
            type: Boolean,
            default: true
        },
        fixedOne: {
            type: Boolean,
            default: true
        },
        clickData: {
            type: Array,
            default: () => []
        },
        minWidth: {
            type: String,
            default: '180'
        },
        format: {
            type: Array,
            default: () => []
        },
        align: {
            type: String,
            default: 'center'
        },
        headerMap: {
            type: Array,
            default: () => []
        },
        defaultWidth: {
            type: String,
            default: ''
        },
        rightWidth: Number,
        position: {
            type: String,
            default: 'right'
        },
        fetchList: Function,
        pageModel: {
            type: Object,
            default: () => null
        },
        selectRowKey: String
    },
    watch: {
        tableHeaders: {
            deep: true,
            handler(val) {
                this.cloneHeaders = cloneDeep(val);
            }
        },
        tableData(val) {
            this.cloneData = val;
        },
        headerMap() {
            this.headerMaps = this.headerMap;
        }
    },
    components: {
        NodeContent: {
            props: {
                node: {
                    required: true
                },
                h: {
                    require: true,
                    type: Function
                }
            },
            render(createElement) {
                const h = this.h;
                const node = this.node;
                return h(createElement, { node });
            }
        }
    },
    computed: {
        fixedWidth() {
            let l = this.clickData.length ? this.clickData.length : '1';
            return this.widthMap[l] || '100';
        },
        _tableHeaders() {
            return this.cloneHeaders;
        },
        isShowSearch() {
            return this.searchList.length > 0;
        }
    },
    methods: {
        copyTabel(txt_str) {
            const input = document.createElement('input');
            document.body.appendChild(input);
            input.setAttribute('value', txt_str);
            input.select();
            let _t = this;
            if (document.execCommand('copy')) {
                document.execCommand('copy');
                this.$message.success('复制成功！');
            }
            document.body.removeChild(input);
        },
        filterTotal(num) {
            return parseInt(num).toLocaleString();
        },
        rowClassName({ row, rowIndex }) {
            if (!this.select || !this.selectRowKey) return '';

            return this.selIds.indexOf(row[this.selectRowKey]) !== -1
                ? 'table-row-light'
                : '';
        },
        // 每页大小改变
        handleSizeChange(e) {
            this.pageModel.size = e;
            this.fetchList && this.fetchList();
        },
        // 当前页面改变
        handleCurrentChange(e) {
            this.pageModel.page = e;
            this.fetchList && this.fetchList();
        },
        selectionChange(selection) {
            if (this.selectRowKey) {
                this.selIds = selection.map((item) => item[this.selectRowKey]);
            }

            this.$emit('selectionChange', selection);
        },
        getData() {
            return this.cloneData;
        },
        clickFirst(value, item, index) {
            this.$emit('clickRow', value, item, index);
        },
        handleClick(data) {
            this.$emit('clickRight', data);
        },
        // 过滤表格tag方法
        formatTag(row, key) {
            return key.tag?.fun(row) || 'success';
        },
        // 过滤表格数据
        formatRow(row, key) {
            if (key.hasOwnProperty('filter')) {
                return key.filter(row);
            }
            if (key.hasOwnProperty('type')) {
                let type = key.type.split('|');
                return (
                    formatTable[type[0]](row[key.headerKey], type[1]) +
                        (key.tips || '') || '-'
                );
            }
            if (key.hasOwnProperty('rules')) {
                let text =
                    row[key.rules.key] === key.rules.value
                        ? key.rules.success
                        : key.rules.error;
                return (row[key.headerKey] && row[key.headerKey] + text) || '-';
            }
            if (row[key.headerKey] === '-' && key.tips) {
                return '-';
            }
            if (key.hasOwnProperty('maps')) {
                return key.maps[row[key.headerKey]];
            }
            return (
                (row[key.headerKey] && row[key.headerKey] + (key.tips || '')) ||
                '-'
            );
        },
        checkDropdown(index, item, row) {
            let flag = false;
            if (item.value === true) {
                flag = row[item.key];
            } else {
                flag = row[item.key] === item.value;
            }
            return index > 0 && flag;
        },
        filterClickData(data, row) {
            let _data = cloneDeep(data);
            let __data = _data.filter((item) => {
                if (item.disabled) {
                    return false;
                } else if (
                    !item.hasOwnProperty('key') &&
                    !item.hasOwnProperty('rule')
                ) {
                    return true;
                } else if (row) {
                    if (item.result === true) {
                        return row[item.key];
                    } else if (item.sym) {
                        return row[item.key] !== item.result;
                    } else if (item.hasOwnProperty('rule')) {
                        return item.rule(row);
                    } else {
                        return row[item.key] === item.result;
                    }
                } else {
                    return true;
                }
            });
            return __data;
        },
        selectRow(selection, row) {
            if (this.select === 'radio') {
                this.$refs.table.clearSelection();
                if (isEqual(row, this.cloneRow)) {
                    this.cloneRow = null;
                    this.$emit('selectRow', [], {});
                } else {
                    this.cloneRow = row;
                    this.$refs.table.toggleRowSelection(row);
                    this.$emit('selectRow', row ? [row] : [], row);
                }
            } else {
                this.$emit('selectRow', selection, row);
            }
        },
        setSelect(row) {
            row.forEach((item) => {
                this.$refs.table.toggleRowSelection(item);
            });
        },
        selectable(row, index) {
            // 判断是否可以勾选
            if (row.scope === 0 || row.scope > 0) {
                return false;
            } else {
                return true;
            }
        },
        changeInput(val) {
            this.$emit('change', val);
        },
        initSort() {
            const el = document.querySelectorAll(
                '.el-table__body-wrapper > table > tbody'
            )[0];
            // const sortable = new Sortable(el, options);
            // 根据具体需求配置options配置项
            const sortable = new Sortable(el, {
                onEnd: (evt) => {
                    // 监听拖动结束事件
                    console.log(this); // this是当前vue上下文
                    // console.log(evt.oldIndex); // 当前行的被拖拽前的顺序
                    // console.log(evt.newIndex); // 当前行的被拖拽后的顺序
                    this.$emit('sort', evt.oldIndex, evt.newIndex)
                    // 这里就可以写我们需要传给后台的逻辑代码
                    // 我们有了 evt.oldIndex 和 evt.newIndex 这两个参数做索引，我们可以根据绑定在表格上面的 data 这个 Array 找到两个相应的记录。就可以针对数据进行操作啦。
                    // 下面将拖拽后的顺序进行修改
                    
                   
                }
            });
        }
    },
    mounted() {
        if (this.sortable) {
            this.initSort()
        }
    }
};
</script>

<style lang="less">
.click-color_danger {
    color: red !important;
}
.new-icon__name {
    width: 24px !important;
    height: 24px !important;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 999;
}
.header-wrapper {
    width: 100%;
    padding: 0 !important;
    position: relative;
    top: 4px;

    .el-icon-caret-bottom,
    .el-icon-caret-top {
        cursor: pointer;
    }
}
.el-table_radio {
    .el-checkbox__inner {
        border-radius: 50%;
    }

    .el-table__fixed-header-wrapper {
        .el-checkbox {
            display: none;
        }
    }
}
.row-radio {
    width: 14px;
    overflow: hidden;
    margin: 0 auto;
}

.hi-table-wrapper {
    position: relative;

    .el-table__header {
        thead {
            th {
                padding: 6px 0 !important;
            }
        }
    }
    tbody {
        td {
            padding: 6px 0 !important;
        }
    }
    &.hide-header {
        .el-table__header-wrapper {
            display: none;
        }
    }
}
.hi-table-wrapper:after {
    left: 0px;
    position: absolute;
    content: '';
    top: 0;
    height: 100%;
    width: 1px;
    background: #e6ebf5;
    z-index: 999;
}

.nb-image {
    width: 80px;
    height: 80px;
}

.input-symbol {
    right: 10px;
    line-height: 40px;
    position: absolute;
    z-index: 9;
    color: #ccc;
}

.table-a-wrapper {
    .mark-self {
        position: absolute;
        right: 0px;
        top: 17px;
        background: white;
        transition: all 0.2s linear;
    }
}
.hover-row {
    .table-a-wrapper {
        .mark-self {
            position: absolute;
            right: 0px;
            top: 17px;
            background: #f5f5f5;
        }
    }
}
// .table-a-wrapper {
//     color: @primary-color !important;
//     cursor: pointer;
// }
.pagination-wrapper {
    display: flex;
    // justify-content: flex-end;
    align-items: center;
    padding: 10px 5px;
    padding-right: 120px;
    position: relative;
    .pagination-total {
        color: #606266;
        font-size: 13px;
        font-weight: 400;
        white-space: nowrap;
        margin-left: 20px;
        flex: 1;
    }
    .el-pagination {
        // width: 100%;
        // position: relative;
        // .el-pagination__jump {
        //     display: none;
        // }
        .el-pagination__sizes {
            position: absolute;
            right: 0;
            top: 10px;
        }
        .el-pagination__total {
            display: none;
        }
    }
}
.table-copy {
    cursor: pointer;
    &:active {
        opacity: 0.7;
    }
}

.table-row-light {
    background: rgba(246, 249, 255, 1) !important;
}
</style>
